import { render } from "./Collapse.vue?vue&type=template&id=6c819428&scoped=true"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=6c819428&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c819428"]])

export default __exports__